import packageInfo from '../../../package.json';
import { documentationUrls } from './documentation-urls';

export const environment = {
  environment: 'staging',
  production: false,
  devMode: false, //disables annoying features like lockscreen while developing
  ssoAllowed: true, // only available on staging & production

  version: packageInfo?.version,

  authAppURL: 'https://loginstaging.reconcept.nl',
  authApiURL: 'https://api.portfoliostaging.reconcept.nl',

  portfolioClientName: 'APOLLO_PORTFOLIO',
  portfolioAppURL: 'https://portfoliostaging.reconcept.nl',
  portfolioApiURL: 'https://api.portfoliostaging.reconcept.nl/graphql',

  aiApiUrl: 'https://api.aistaging.reconcept.nl/api/ai',

  workspaceAppURL: 'https://workspacestaging.reconcept.nl',
  workspaceApiURL: 'https://api.portfoliostaging.reconcept.nl/graphql',

  ...documentationUrls,

  // the authenticator title for this specific environment
  otpIssuer: 'Reconcept Staging',
  otpBannerEnabled: false,

  environmentIndicator: {
    color: 'red',
    text: `Staging`,
    icon: 'exclamation-triangle',
  },
};
